<template>
  <div class="footer-menu"
       :class="isOpen ? '_open' : null">
    <div class="footer-menu__title" v-if="windowSizeMixin.width > WINDOW_SIZE_SM">
      {{ name }}
    </div>
    <div class="footer-menu__title"
         v-else
         @click.prevent="onMenuToggle">
      {{ name }}
      <BaseSvg name="ico-arrow"
               width=".9rem"
               height=".6rem"
               class="footer-menu__arrow"/>
    </div>
    <v-slide-toggle
      :active="windowSizeMixin.width > WINDOW_SIZE_SM ? true : isOpen"
      class="footer-menu__list-wrap">
      <ul class="footer-menu__list">
        <li v-for="item in menu"
            :key="item.id">
          <a v-if="item.target === '_blank'"
             :href="formatClientLink(item.url)">
            {{ item.title_translations[currentLocale] }}
          </a>
          <router-link-modified v-else
                                :to="formatClientLink(item.url)">
            {{ item.title_translations[currentLocale] }}
          </router-link-modified>
        </li>
      </ul>
    </v-slide-toggle>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import windowSizeMixin from '@/mixins/windowSizeMixin'
  import formatClientLink from '@/helpers/formatClientLink'
  import {WINDOW_SIZE_SM} from "@/constants/windowSizes"

  export default {
    name: "FooterMenu",
    mixins: [windowSizeMixin],
    props: {
      name: String,
      menu: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        isOpen: false,
        WINDOW_SIZE_SM
      }
    },
    computed: {
      ...mapState([
        'currentLocale',
      ])
    },
    methods: {
      onMenuToggle() {
        this.isOpen = !this.isOpen
      },
      formatClientLink
    }
  }
</script>

<style>

</style>
